import { siteCategories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-3xl font-heading text-foreground-950 mb-3">
            Popularne Kategorie Produktów
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Przeglądaj nasze kategorie i znajdź dokładnie to, czego szukasz. Każda kategoria zawiera starannie wyselekcjonowane produkty.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {siteCategories.map((cat) => (
            <a
              key={cat.nameEn}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col bg-background-50 border border-background-200/70 rounded-lg overflow-hidden cursor-pointer hover:border-primary-300 transition-all duration-200"
            >
              <div className="relative w-full h-32 md:h-36 overflow-hidden">
                <img
                  src={cat.image}
                  alt={`Kategoria ${cat.name} - Kakobuy Spreadsheet`}
                  title={`${cat.name} - Kakobuy Spreadsheet Polska`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
              </div>
              <div className="flex items-center gap-2 px-3 py-3">
                <span className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-100/80 text-primary-500">
                  <i className={`${cat.icon} text-xs`}></i>
                </span>
                <span className="text-xs md:text-sm text-foreground-700 font-medium whitespace-nowrap group-hover:text-primary-500 transition-colors">
                  {cat.name}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}